import axios from "axios";
import { firebaseRequestURI } from "../../utils/_helpers";

export const LOADING_POPULAR_MEALS = "LOADING_POPULAR_MEALS";
export const POPULAR_MEALS_LOADED = "POPULAR_MEALS_LOADED";
export const POPULAR_MEALS_LOADED_ERROR = "POPULAR_MEALS_LOADED_ERROR";

export const getPopularMeals = (startDate, endDate, type) => (dispatch) => {
  dispatch({ type: LOADING_POPULAR_MEALS });
  axios({
    method: "GET",
    url: `${firebaseRequestURI}/meals?startDate=${startDate}&endDate=${endDate}&type=${type}`,
  })
    .then((response) => {
      dispatch({
        type: POPULAR_MEALS_LOADED,
        payload: response.data.mostPopularMeals,
      });
    })
    .catch((error) => {
      dispatch({
        type: POPULAR_MEALS_LOADED_ERROR,
        payload:
          error?.response?.data?.message ||
          "Something went wrong, please try again.",
      });
    });
};
